import {
  DeleteObservationHandler,
  ObservationHandler,
  ObservationsParams,
  ObservationsResult,
} from './types'
import { useObservations } from './useObservations'

interface ObservationsProps {
  params: ObservationsParams
  children: (props: {
    observations?: ObservationsResult
    isFetching: boolean
    isDeleting: boolean
    hasMore: boolean
    loadObservations: () => void
    loadMore: () => void
    addObservation: ObservationHandler
    removeObservation: ObservationHandler
    updateObservation: ObservationHandler
    deleteObservation: DeleteObservationHandler
  }) => JSX.Element | null
}

const Observations = ({ params, children }: ObservationsProps) => {
  const props = useObservations({ params })

  return children(props)
}

export default Observations
